var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTikTok = function SvgTikTok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.727 7.48a6.82 6.82 0 0 1-2.28-2.458 6.793 6.793 0 0 1-.828-3.244H16.71l-.009 19.598a4.098 4.098 0 0 1-.77 2.238 4.134 4.134 0 0 1-6.319.452 4.103 4.103 0 0 1-.821-4.457 4.112 4.112 0 0 1 1.52-1.818 4.13 4.13 0 0 1 2.274-.68c.413.001.824.065 1.217.19v-4.993a9.026 9.026 0 0 0-1.217-.088c-4.98 0-9.03 4.037-9.03 9.001a9 9 0 0 0 2.65 6.361 9.06 9.06 0 0 0 6.382 2.64c4.98 0 9.03-4.037 9.03-9v-9.939a11.694 11.694 0 0 0 6.826 2.19V8.58a6.802 6.802 0 0 1-3.717-1.101Z",
    fill: "currentColor"
  })));
};
export default SvgTikTok;